import { useMemo } from 'react';

import getRandomString from '@shared/utils/getRandomString';

export default function useRandomString(length = 6) {
  const randomString = useMemo(() => getRandomString(length), []);
  return randomString;
}
